import React from "react";
import logger from "./../../logger";
import AOS from "aos";
import $ from "jquery";
import "./css/css2.css";
import "./css/bootstrap.min.css";
import "./css/icofont.min.css";
import "./css/font-awesome.min.css";
import "./css/style.css";
import Constants from "./../../Utils/Constants";
import rightarrow_button_svg from "./img/right-arrow-button.svg";
import hero_img_svg from "./img/hero-img.svg";
import platform_features_svg from "./img/platform-features.svg";
import automation_builder_svg from "./img/automation-builder.svg";
import campaign_builder_svg from "./img/campaign-builder.svg";
import checkmark_svg from "./img/checkmark.svg";

function Home(props) {
  logger.log("Home new rendered");

  React.useEffect(() => {
    if ($("#preloader").length) {
      $("#preloader")
        .delay(100)
        .fadeOut("slow", function() {
          $(this).remove();
          logger.log("removing!");
        });
    }
  }, []);

  React.useEffect(() => {
    const location = window.location;
    //require('./js/bootstrap.min.js')
    // Preloader
    /*$(window).on("load", function () {
      if ($("#preloader").length) {
        $("#preloader")
          .delay(100)
          .fadeOut("slow", function () {
            $(this).remove();
            logger.log("removing!")
          });
      }
    });*/

    // Smooth scroll for the navigation menu and links with .scrollto classes
    $(document).on("click", ".nav-menu a, .mobile-nav a, .scrollto", function(
      e
    ) {
      if (
        location.pathname.replace(/^\//, "") ==
          this.pathname.replace(/^\//, "") &&
        location.hostname == this.hostname
      ) {
        var target = $(this.hash);
        if (target.length) {
          e.preventDefault();

          var scrollto = target.offset().top;
          var scrolled = 20;

          if ($("#header").length) {
            scrollto -= $("#header").outerHeight();

            if (!$("#header").hasClass("header-scrolled")) {
              scrollto += scrolled;
            }
          }

          if ($(this).attr("href") == "#header") {
            scrollto = 0;
          }

          $(".html, .body").animate(
            {
              scrollTop: scrollto,
            },
            1500,
            "easeInOutExpo"
          );

          if ($(this).parents(".nav-menu, .mobile-nav").length) {
            $(".nav-menu .active, .mobile-nav .active").removeClass("active");
            $(this)
              .closest("li")
              .addClass("active");
          }

          if ($(".body").hasClass("mobile-nav-active")) {
            $(".body").removeClass("mobile-nav-active");
            $(".mobile-nav-toggle i").toggleClass(
              "icofont-navigation-menu icofont-close"
            );
            $(".mobile-nav-overly").fadeOut();
          }
          return false;
        }
      }
    });

    // Mobile Navigation

    if ($(".nav-menu").length) {
      var $mobile_nav = $(".nav-menu")
        .clone()
        .prop({
          class: "mobile-nav d-lg-none",
        });
      $(".body").append($mobile_nav);
      $(".body").prepend(
        '<button type="button" class="mobile-nav-toggle d-lg-none"><i class="icofont-navigation-menu"></i></button>'
      );
      $(".body").append('<div class="mobile-nav-overly"></div>');

      $(document).on("click", ".mobile-nav-toggle", function(e) {
        $(".body").toggleClass("mobile-nav-active");
        $(".mobile-nav-toggle i").toggleClass(
          "icofont-navigation-menu icofont-close"
        );
        $(".mobile-nav-overly").toggle();
      });

      $(document).on("click", ".mobile-nav .drop-down > a", function(e) {
        e.preventDefault();
        $(this)
          .next()
          .slideToggle(300);
        $(this)
          .parent()
          .toggleClass("active");
      });

      $(document).click(function(e) {
        var container = $(".mobile-nav, .mobile-nav-toggle");
        if (!container.is(e.target) && container.has(e.target).length === 0) {
          if ($(".body").hasClass("mobile-nav-active")) {
            $(".body").removeClass("mobile-nav-active");
            $(".mobile-nav-toggle i").toggleClass(
              "icofont-navigation-menu icofont-close"
            );
            $(".mobile-nav-overly").fadeOut();
          }
        }
      });
    } else if ($(".mobile-nav, .mobile-nav-toggle").length) {
      $(".mobile-nav, .mobile-nav-toggle").hide();
    }

    // Navigation active state on scroll
    var nav_sections = $("section");
    var main_nav = $(".nav-menu, #mobile-nav");

    $(window).on("scroll", function() {
      var cur_pos = $(this).scrollTop() + 90;

      nav_sections.each(function() {
        var top = $(this).offset().top,
          bottom = top + $(this).outerHeight();

        if (cur_pos >= top && cur_pos <= bottom) {
          if (cur_pos <= bottom) {
            main_nav.find("li").removeClass("active");
          }
          main_nav
            .find('a[href="#' + $(this).attr("id") + '"]')
            .parent("li")
            .addClass("active");
        }
        if (cur_pos < 300) {
          $(".nav-menu ul:first li:first").addClass("active");
        }
      });
    });

    // Toggle .header-scrolled class to #header when page is scrolled
    document.addEventListener(
      "scroll",
      (event) => {
        if (event.target.scrollTop > 100) {
          $("#header").addClass("header-scrolled");
        } else {
          $("#header").removeClass("header-scrolled");
        }
      },
      true
    );

    if ($(window).scrollTop() > 100) {
      $("#header").addClass("header-scrolled");
    }

    // Porfolio isotope and filter

    $(window).on("load", function() {
      var $portfolio = $(".portfolio-items");
      if ($portfolio.length) {
        var portfolioIsotope = $(".portfolio-container").isotope({
          itemSelector: ".portfolio-item",
        });

        $("#portfolio-flters li").on("click", function() {
          $("#portfolio-flters li").removeClass("filter-active");
          $(this).addClass("filter-active");

          portfolioIsotope.isotope({
            filter: $(this).data("filter"),
          });
          aos_init();
        });

        // Initiate venobox (lightbox feature used in portofilo)
        $(document).ready(function() {
          $(".venobox").venobox({
            share: false,
          });
        });
      }
    });

    // Portfolio details carousel
    /*
    $(".portfolio-details-carousel").owlCarousel({
      autoplay: true,
      dots: true,
      loop: true,
      items: 1,
    });*/

    // Initi AOS
    function aos_init() {
      AOS.init({
        duration: 1000,
        once: true,
      });
    }
    $(window).on("load", function() {
      aos_init();
    });
  }, []);

  return (
    <div className="body html">
      <header id="header" className="fixed-top">
        <div className="container d-flex align-items-center justify-content-between">
          <a href={Constants.home} className="logo">
            <svg
              width="193"
              height="24"
              viewBox="0 0 193 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.212 1.84082H19.4595L12.7151 22.4002H8.12834L1.39746 1.84082H5.64497L9.3768 14.0752C9.58489 14.7971 9.79748 15.6408 10.0146 16.6064C10.2408 17.5628 10.381 18.2284 10.4353 18.6034C10.5348 17.7408 10.8741 16.2314 11.4531 14.0752L15.212 1.84082ZM28.1445 10.3065L32.2835 1.84082H36.8159L30.2343 14.3986V22.4002H26.0547V14.5393L19.4731 1.84082H24.0327L28.1445 10.3065ZM39.3129 1.84082H45.4873C48.301 1.84082 50.3411 2.258 51.6076 3.09239C52.8833 3.91738 53.5211 5.23456 53.5211 7.04394C53.5211 8.27207 53.2405 9.27988 52.6796 10.0674C52.1278 10.8549 51.3905 11.3283 50.4677 11.4877V11.6283C51.7253 11.9189 52.6299 12.4627 53.1817 13.2596C53.7427 14.0565 54.0232 15.1158 54.0232 16.4376C54.0232 18.3127 53.3673 19.7752 52.0554 20.8252C50.7527 21.8752 48.9796 22.4002 46.7358 22.4002H39.3129V1.84082ZM43.5197 9.98301H45.9624C47.1022 9.98301 47.9255 9.8002 48.4322 9.43456C48.9478 9.06895 49.2056 8.46426 49.2056 7.62052C49.2056 6.83301 48.9252 6.27052 48.3643 5.93301C47.8125 5.58613 46.9349 5.41269 45.7316 5.41269H43.5197V9.98301ZM43.5197 13.4424V18.8002H46.2609C47.4189 18.8002 48.2738 18.5704 48.8256 18.1111C49.3776 17.6517 49.6535 16.9487 49.6535 16.0018C49.6535 14.2955 48.4775 13.4424 46.1252 13.4424H43.5197ZM62.1925 10.9674H63.5495C64.8794 10.9674 65.8609 10.7377 66.4942 10.2783C67.1276 9.81895 67.4441 9.09708 67.4441 8.11269C67.4441 7.1377 67.1185 6.44394 66.4671 6.03144C65.8248 5.61895 64.8252 5.41269 63.468 5.41269H62.1925V10.9674ZM62.1925 14.5111V22.4002H57.9857V1.84082H63.7666C66.4626 1.84082 68.4574 2.35176 69.7512 3.37364C71.0449 4.38613 71.6917 5.92832 71.6917 8.0002C71.6917 9.20957 71.3705 10.2877 70.7282 11.2346C70.0859 12.1721 69.1766 12.908 68.0006 13.4424C70.986 18.0642 72.9312 21.0501 73.8358 22.4002H69.1677L64.4316 14.5111H62.1925ZM93.9334 22.4002H88.5867L79.9561 6.84708H79.8339C80.0058 9.59394 80.0916 11.5533 80.0916 12.7252V22.4002H76.3328V1.84082H81.6387L90.2559 17.2392H90.3509C90.2152 14.5674 90.1472 12.6783 90.1472 11.5721V1.84082H93.9334V22.4002ZM106.595 22.4002H102.388V5.46895H97.0003V1.84082H111.982V5.46895H106.595V22.4002Z"
                fill="white"
              />
              <path
                d="M134.875 16.1559C134.875 17.4308 134.563 18.5652 133.939 19.559C133.315 20.5433 132.415 21.3121 131.239 21.8652C130.063 22.4091 128.683 22.6809 127.1 22.6809C125.779 22.6809 124.671 22.5871 123.775 22.3996C122.879 22.2028 121.947 21.8652 120.979 21.3871V16.4371C122.002 16.9809 123.065 17.4075 124.168 17.7167C125.272 18.0167 126.285 18.1668 127.208 18.1668C128.004 18.1668 128.588 18.0262 128.959 17.7449C129.33 17.4543 129.515 17.0839 129.515 16.634C129.515 16.3527 129.438 16.1091 129.285 15.9027C129.14 15.6871 128.9 15.4715 128.565 15.2559C128.24 15.0402 127.362 14.5996 125.933 13.934C124.639 13.3246 123.666 12.734 123.015 12.1621C122.373 11.5902 121.893 10.934 121.577 10.1934C121.269 9.45273 121.115 8.57617 121.115 7.56367C121.115 5.66993 121.78 4.19335 123.11 3.13398C124.44 2.07462 126.267 1.54492 128.592 1.54492C130.646 1.54492 132.74 2.03711 134.875 3.02148L133.233 7.31055C131.379 6.42929 129.778 5.98867 128.43 5.98867C127.733 5.98867 127.226 6.11524 126.91 6.36836C126.593 6.62148 126.435 6.93555 126.435 7.31055C126.435 7.71367 126.634 8.07462 127.032 8.39335C127.439 8.71211 128.534 9.29335 130.316 10.1371C132.026 10.934 133.211 11.7918 133.871 12.7106C134.541 13.6199 134.875 14.7684 134.875 16.1559ZM153.806 22.3996L149.749 7.5918H149.626C149.816 10.1137 149.911 12.0731 149.911 13.4699V22.3996H145.162V1.84023H152.3L156.438 16.4371H156.548L160.605 1.84023H167.756V22.3996H162.83V13.3855C162.83 12.9168 162.835 12.3965 162.844 11.8246C162.861 11.2527 162.925 9.85118 163.034 7.61993H162.912L158.909 22.3996H153.806ZM192.224 16.1559C192.224 17.4308 191.912 18.5652 191.288 19.559C190.663 20.5433 189.762 21.3121 188.587 21.8652C187.411 22.4091 186.031 22.6809 184.448 22.6809C183.126 22.6809 182.019 22.5871 181.124 22.3996C180.228 22.2028 179.296 21.8652 178.328 21.3871V16.4371C179.35 16.9809 180.413 17.4075 181.516 17.7167C182.62 18.0167 183.634 18.1668 184.556 18.1668C185.353 18.1668 185.936 18.0262 186.307 17.7449C186.677 17.4543 186.863 17.0839 186.863 16.634C186.863 16.3527 186.787 16.1091 186.633 15.9027C186.488 15.6871 186.248 15.4715 185.913 15.2559C185.587 15.0402 184.71 14.5996 183.281 13.934C181.987 13.3246 181.014 12.734 180.363 12.1621C179.72 11.5902 179.242 10.934 178.925 10.1934C178.618 9.45273 178.463 8.57617 178.463 7.56367C178.463 5.66993 179.129 4.19335 180.458 3.13398C181.788 2.07462 183.616 1.54492 185.941 1.54492C187.995 1.54492 190.088 2.03711 192.224 3.02148L190.582 7.31055C188.726 6.42929 187.125 5.98867 185.777 5.98867C185.081 5.98867 184.575 6.11524 184.258 6.36836C183.942 6.62148 183.782 6.93555 183.782 7.31055C183.782 7.71367 183.982 8.07462 184.38 8.39335C184.788 8.71211 185.882 9.29335 187.664 10.1371C189.373 10.934 190.559 11.7918 191.22 12.7106C191.888 13.6199 192.224 14.7684 192.224 16.1559Z"
                fill="#00AAF6"
              />
            </svg>
          </a>

          <nav className="nav-menu d-none d-lg-block">
            <ul>
              <li>
                <a href="#">Tools</a>
              </li>
              <li>
                <a
                  href="https://vybrntsms-static.s3-ap-southeast-2.amazonaws.com/VybrntSMS-Quick-Start-Guide.pdf"
                  download
                >
                  Quick Start Guide
                </a>
              </li>
              <li>
                <a
                  href="https://vybrnt.com/blog/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Blog
                </a>
              </li>
              <li>
                <a
                  href="http://vybrnt.com/contact"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Customer Care
                </a>
              </li>
              <li>
                <a href="#">Contact Login</a>
              </li>
              <li className="mobile-menu-link">
                <a
                  href={Constants.signup}
                  onClick={(e) => {
                    e.preventDefault();
                    props.history.push(Constants.signup);
                  }}
                >
                  Create Account
                </a>
              </li>
              <li className="mobile-menu-link">
                <a
                  href={Constants.login}
                  onClick={(e) => {
                    e.preventDefault();
                    props.history.push(Constants.login);
                  }}
                >
                  Sign in
                </a>
              </li>
            </ul>
          </nav>

          <div className="login-link">
            <a
              href={Constants.signup}
              onClick={(e) => {
                e.preventDefault();
                props.history.push(Constants.signup);
              }}
            >
              Create Account
            </a>
            <a
              href={Constants.login}
              onClick={(e) => {
                e.preventDefault();
                props.history.push(Constants.login);
              }}
              className="get-started-btn"
            >
              Sign In
            </a>
          </div>
        </div>
      </header>
      <section className="hero">
        <div className="container">
          <div className="row">
            <div
              className="col-lg-7 d-flex flex-column justify-content-start pt-4 pt-lg-32 order-2 order-lg-1"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <h1>
                Maximise your ActiveCampaign platform with{" "}
                <span className="heading-sms">VYBRNT SMS!</span>
              </h1>
              <p>
                The SMS Platform built specifically for ActiveCampaign users. A
                simple yet, effective SMS add-on to your ActiveCampaign
                platform!
              </p>
              <div className="CTA">
                <a href={Constants.login} className="btn-get-started">
                  Get Started
                </a>
                <a href="#" className="btn-watch-video">
                  No credit card required to create account
                </a>
              </div>
              <a href="#" className="arrow-link">
                Learn more
                <img src={rightarrow_button_svg} />
              </a>
            </div>

            <div
              className="col-lg-5 order-1 order-lg-2 hero-img text-right"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <img src={hero_img_svg} className="img-fluid animated" alt="" />
            </div>
          </div>
        </div>
      </section>
      <section className="services">
        <div className="container aos-init aos-animate" data-aos="fade-up">
          <div className="section-title">
            <h2>
              The SMS Platform built specifically for ActiveCampaign users
            </h2>
            <p>
              A simple yet, effective SMS add-on to your ActiveCampaign
              platform!
            </p>
          </div>
          <div className="row">
            <div className="col-xl-4 col-md-6 col-lg-4 d-flex align-items-stretch">
              <div className="icon-box">
                <img
                  src={platform_features_svg}
                  className="service-icon"
                  alt=""
                />
                <h4>Platform Features</h4>
                <ul>
                  <li>
                    Send your SMS from your own business name. Create a custom
                    sender ID up to 11 characters.
                  </li>
                  <li>
                    Available for most countries outside of North America, such
                    as Australia and the UK.
                  </li>
                  <li>
                    Send SMS promotional campaigns, sync’d with your
                    ActiveCampaign lists. Easy bulk sending to your database.
                  </li>
                  <li>
                    Add SMS to your automations with an easy Webhook builder.
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-xl-4 col-md-6 col-lg-4 d-flex align-items-stretch">
              <div className="icon-box">
                <img
                  src={automation_builder_svg}
                  className="service-icon"
                  alt=""
                />
                <h4>Automation Builder</h4>
                <ul>
                  <li>
                    Easily create messages for your ActiveCampaign Nurture
                    Sequences
                  </li>
                  <li>WebHook Format for Automation Triggers</li>
                  <li>Create a library of SMS messages</li>
                  <li>Personalisation tags</li>
                  <li>Customise Sender ID</li>
                  <li>Opt-out management</li>
                </ul>
              </div>
            </div>

            <div className="col-xl-4 col-md-12 col-lg-4 d-flex align-items-stretch">
              <div className="icon-box">
                <img
                  src={campaign_builder_svg}
                  className="service-icon"
                  alt=""
                />
                <h4>Campaign Builder</h4>
                <ul>
                  <li>Send bulk SMS campaigns to your audience.</li>
                  <li>Sync ActiveCampaign lists and subscribers</li>
                  <li>Create an SMS specific list</li>
                  <li>Custom sender ID</li>
                  <li>Opt-Out Management</li>
                  <li>Personalization</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="CTA-btn btn-blue">
            <a
              href="https://www.activecampaign.com/?_r=WEH67FJT"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-large"
            >
              Don’t have an ActiveCampaign account yet? Get one here!
              <img src={rightarrow_button_svg} />
            </a>
          </div>
        </div>
      </section>
      <section className="mail-cta">
        <div className="container">
          <div className="mail-cta-content">
            <h3>
              Subscribe to receive Marketing Automation guides and strategies.
            </h3>
            <form action="" method="post">
              <input
                type="email"
                name="email"
                placeholder="Your Email-Address"
              />
              <input type="submit" value="submit" className="btn" />
            </form>
          </div>
        </div>
      </section>
      <section className="get-in-touch">
        <div className="container aos-init aos-animate" data-aos="fade-up">
          <div className="section-title">
            <h2 className="big-heading">Get in touch</h2>
            <h3>
              Contact us to get product support. Also, if your an Agency, find
              out more about our multi account features, and white label
              options.
            </h3>
            <p>
              Please suggest more features! This platform has been developed by
              ActiveCampaign users, for ActiveCampaign users. Feel free to send
              through feature requests here...
            </p>
          </div>

          <form action="" method="post" role="form" className="contact-form">
            <div className="form-row m-0">
              <div className="form-group col-md-6">
                <input
                  type="text"
                  name="first-name"
                  className="form-control"
                  placeholder="Your first name"
                  required
                />
              </div>

              <div className="form-group col-md-6">
                <input
                  type="text"
                  name="last-name"
                  className="form-control"
                  placeholder="Your last name"
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <input
                type="email"
                className="form-control"
                name="email"
                placeholder="Your e-mail address"
                required
              />
            </div>

            <div className="form-group">
              <textarea
                className="form-control"
                name="message"
                rows="5"
                placeholder="Enter here your message"
              />
            </div>

            <div className="text-center">
              <button type="submit" className="btn">
                Send Message
              </button>
            </div>
          </form>
        </div>
      </section>
      <section className="sms-tips">
        <div className="container">
          <div className="section-title">
            <h2 className="big-heading">
              Download 8 mistakes of SMS Marketing. Read this to ensure your
              starting on the right foot!
            </h2>
            <a href="#" className="btn">
              Click Here
            </a>
          </div>
        </div>
      </section>
      <section className="coming-soon">
        <div className="container">
          <div className="coming-soon-content">
            <h3>Coming Soon!</h3>
            <div className="coming-soon-feature">
              <div className="feature-list">
                <img src={checkmark_svg} />
                <p>Two-Way SMS</p>
              </div>
              <div className="feature-list">
                <img src={checkmark_svg} />
                <p>Analytics and Link Tracking</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <footer id="footer">
        <div className="footer-top">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 col-md-6 footer-contact">
                <h3>Take contact</h3>
                <p>
                  Interested? Contact us and we will be happy to tell you more
                  about our services!
                </p>
                <ul className="contact-info">
                  <li>
                    <i class="fa fa-map-marker" aria-hidden="true" />
                    <a
                      href="https://vybrnt.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      vybrnt.com
                    </a>
                  </li>
                  <li>
                    <i className="fa fa-envelope" aria-hidden="true" />
                    <a href="mailto:@info@vybrnt.com">@info@vybrnt.com</a>
                  </li>
                  <li>
                    <i className="fa fa-phone" aria-hidden="true" />
                    <a href="tel:+61390136577">+61 3 9013 6577</a>
                  </li>
                </ul>
              </div>

              <div className="col-lg-2 col-md-3 footer-links">
                <ul>
                  <li>
                    <a
                      href="https://vybrntsms-static.s3-ap-southeast-2.amazonaws.com/VybrntSMS-Quick-Start-Guide.pdf"
                      download
                    >
                      Quick Start Guide
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://vybrnt.com/blog"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Blog
                    </a>
                  </li>
                  <li>
                    <a href="#">Sign Up Free</a>
                  </li>
                  <li>
                    <a href="#">Tools</a>
                  </li>
                  <li>
                    <a href="#">Customer Care</a>
                  </li>
                </ul>
              </div>

              <div className="col-lg-2 col-md-3 footer-links">
                <ul>
                  <li>
                    <i className="bx bx-chevron-right" />{" "}
                    <a href="#">Contact Login</a>
                  </li>
                  <li>
                    <i className="bx bx-chevron-right" />{" "}
                    <a href="#">Create Account</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="container footer-bottom">
          <div className="copyright">
            Designed and developed by{" "}
            <a
              href="https://vybrnt.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <strong>
                <span>VYBRNT</span>
              </strong>
            </a>{" "}
            Digital Marketing
          </div>
          <div className="social-links">
            <a href="#">
              <i className="fa fa-facebook" aria-hidden="true" />
            </a>
            <a href="#">
              <i className="fa fa-instagram" aria-hidden="true" />
            </a>
            <a href="#">
              <i className="fa fa-twitter" aria-hidden="true" />
            </a>
            <a href="#">
              <i className="fa fa-linkedin" aria-hidden="true" />
            </a>
          </div>
        </div>
      </footer>
      <div id="preloader" />
    </div>
  );
}

export default Home;
